{
  "toast": {
    "masterAdministratorCreated": "Master administrator créé",
    "customPlanCreatedOrganizationCanSubscribeOnSubscription": "Custom plan créé — organization can subscribe on Subscription page",
    "timezoneAdded": "Timezone ajoutered",
    "currencyAdded": "Currency ajoutered",
    "taxModeAdded": "Tax mode ajoutered",
    "added": "Added",
    "testEmailSentCheckTheInboxAndSpam": "Test email sent — check le inbox (and spam folder)",
    "passwordChanged": "Password changed",
    "organizationUpdated": "Organization mis à jour",
    "organizationCreated": "Organization créé",
    "organizationActivated": "Organisation activée",
    "organizationDeactivated": "Organisation désactivée",
    "platformSettingsSaved": "Paramètres de plateforme enregistrés — SSO, e-mail et limites de débit s'appliquent immédiatement"
  },
  "errors": {
    "failedToLoadAnalytics": "Échec du chargement de analytics",
    "failedToCreateMasterAdministrator": "Échec de la création de master administrator",
    "failedToLoadRequests": "Échec du chargement de requests",
    "failedToCreatePlan": "Échec de la création de plan",
    "zoneIdAndLabelAreRequired": "Zone ID et label are requis",
    "currencyCodeAndNameAreRequired": "Currency code et name are requis",
    "decimalPlacesMustBeBetween0And4": "Decimal places must be between 0 et 4",
    "taxModeCodeAndNameAreRequired": "Tax mode code et name are requis",
    "codeAndNameAreRequired": "Le code et le nom sont requis",
    "failedToLoadReferenceData": "Échec du chargement de reference data",
    "couldNotAddTimezone": "Impossible de add timezone",
    "couldNotAddCurrency": "Impossible de add currency",
    "couldNotAddTaxMode": "Impossible de add tax mode",
    "couldNotAddEntry": "Impossible de add entry",
    "enterARecipientEmailForTheTest": "Saisissez a recipient email for the test",
    "testEmailFailedSaveSmtpSettingsFirstThen": "Test email failed — save SMTP paramètres first, then retry",
    "failedToLoadPlatformSettings": "Échec du chargement de platform settings",
    "failedToSaveSettings": "Échec de l'enregistrement de settings",
    "failedToChangePassword": "Échec : change password",
    "orgCodeMustBe13UppercaseLetters": "Org code must be 1–3 uppercase letters ou digits",
    "saveFailed": "Échec de l'enregistrement",
    "failedToLoadPlans": "Échec du chargement de plans",
    "failedToLoadMasterAdministrators": "Échec du chargement de master administrators",
    "failedToLoadUsers": "Échec du chargement de users",
    "failedToLoadOrganizations": "Échec du chargement de organizations",
    "failedToLoad": "Échec : load",
    "activateFailed": "Échec de l'activation",
    "deactivateFailed": "Échec de la désactivation",
    "passwordsMustMatch": "Les mots de passe doivent correspondre"
  },
  "pages": {
    "platformAnalytics": "Platform Analytique",
    "platformInvoicesToday": "Platform Factures Today",
    "salesToday": "Sales Today",
    "salesThisMonth": "Sales Ce Month",
    "masterAdministrators": "Master administrators",
    "newMasterAdministrator": "New master administrator",
    "platformOperatorsWhoCanAccessThe": "Platform operators who can access le master console",
    "customPlanRequests": "Custom plan requests",
    "reviewOrganizationRequestsAndPublishA": "Review organization requests et publish a private plan they can subscribe to.",
    "masterDashboard": "Master Tableau de bord",
    "totalOrganizations": "Total Organizations",
    "activeOrganizations": "Active Organizations",
    "activeSubscriptions": "Active Subscriptions",
    "todaySPlatformSales": "Today's Platform Sales",
    "todaySInvoices": "Today's Factures",
    "monthSales": "Ventes du mois",
    "organizationMetrics": "Organization indicateurs",
    "platformWideOverview": "Platform-wide overview",
    "activeTenantsAndSubscriptions": "Active tenants et subscriptions",
    "referenceData": "Reference data",
    "globalCountriesCurrenciesTimezonesAndTax": "Global countries, currencies, timezones, et tax modes pour tenant onboarding",
    "settings": "Paramètres",
    "security": "Security",
    "changePassword": "Change password",
    "general": "General",
    "ssoGoogleMicrosoft": "SSO (Google & Microsoft)",
    "emailSmtp": "Email (SMTP)",
    "rateLimiting": "Rate limiting",
    "platformConfigurationAccountSecurityAndMaster": "Platform configuration, account security, et master admin preferences.",
    "addAnExtraLayerOfProtection": "Add an extra layer of protection à votre master account.",
    "useAStrongPasswordWithAt": "Use a strong password avec at least 8 characters.",
    "frontendUrlCorsAndMfaIssuer": "Frontend URL, CORS, et MFA issuer.",
    "configureOauthProvidersForSingleSign": "Configure OAuth providers pour single sign-on.",
    "outgoingMailForNotificationsAndPassword": "Outgoing mail pour notifications et password resets.",
    "protectTheApiFromExcessiveRequest": "Protect le API de excessive request volume.",
    "platformUsers": "Platform utiliserrs",
    "trackSignInAccountsAcrossAll": "Track sign-in accounts across all organizations et master operators",
    "organizations": "Organizations",
    "subscriptionPlans": "Subscription Plans",
    "subscriptions": "Subscriptions",
    "organizationSubscriptionStatusAcrossThePlatform": "Organization subscription status across le platform"
  },
  "labels": {
    "firstName": "Prénom *",
    "lastName": "Last name *",
    "email": "Email *",
    "password": "Password *",
    "planName": "Plan name",
    "monthlyPriceInr": "Monthly price (INR)",
    "yearlyPriceInr": "Yearly price (INR)",
    "maxStores": "Max magasins",
    "maxEmployees": "Max employés",
    "maxProducts": "Max produits",
    "description": "Descriptif",
    "internalNotes": "Internal notes",
    "zoneIdIana": "Zone ID (IANA) *",
    "label": "Label *",
    "displayName": "Nom affiché",
    "country": "Pays",
    "region": "Region",
    "currencyCodeIso4217": "Devise code (ISO 4217) *",
    "name": "Nom *",
    "symbol": "Symbole",
    "primaryCountry": "Primary country",
    "decimalPlaces": "Decimal places *",
    "isoNumericCode": "ISO numeric code",
    "taxModeCode": "Tax mode code *",
    "supportedTaxTypes": "Supported tax types",
    "code": "Code",
    "name2": "Nom",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "loadingPlatformSettings": "Loading platform paramètres",
    "frontendUrl": "Frontend URL",
    "corsAllowedOriginsCommaSeparated": "CORS allowed origins (comma-separated)",
    "mfaIssuerName": "MFA issuer name",
    "oauthCallbackBaseUrl": "OAuth callback base URL",
    "clientId": "Client ID",
    "clientSecret": "Client secret",
    "fromEmail": "From email",
    "fromName": "From name",
    "smtpHost": "SMTP host",
    "port": "Port",
    "smtpUsername": "SMTP utiliserrname",
    "smtpPassword": "SMTP password",
    "sendTestEmailTo": "Send test email to",
    "maxRequestsMinute": "Max requests / minute",
    "authEndpointsMaxMinute": "Auth endpoints max / minute",
    "accountType": "Compte type",
    "orgCode": "Code de l'organisation",
    "phone": "Téléphone",
    "gst": "GST",
    "city": "Ville",
    "eGFat": "e.g. FAT"
  },
  "validation": {
    "validEmail": "Saisissez une adresse e-mail valide",
    "passwordMin": "Au moins 8 caractères",
    "firstNameRequired": "Le prénom est requis",
    "lastNameRequired": "Le nom est requis"
  },
  "masterAdmins": {
    "actions": {
      "addMasterAdmin": "Ajouter un administrateur master"
    },
    "columns": {
      "name": "Nom",
      "email": "E-mail",
      "mfa": "MFA",
      "lastSignIn": "Dernière connexion",
      "status": "Statut"
    },
    "values": {
      "active": "Actif",
      "inactive": "Inactif",
      "never": "Jamais",
      "off": "Désactivé",
      "on": "Activé"
    }
  },
  "subscriptions": {
    "columns": {
      "organization": "Organisation",
      "plan": "Forfait",
      "status": "Statut",
      "contact": "Contact"
    }
  },
  "users": {
    "actions": {
      "manageMasterAdmins": "Gérer les administrateurs master"
    },
    "columns": {
      "name": "Nom",
      "email": "E-mail",
      "organization": "Organisation",
      "role": "Rôle",
      "type": "Catégorie",
      "verified": "Vérifié",
      "status": "Statut",
      "lastLogin": "Dernière connexion",
      "created": "Créé"
    },
    "empty": {
      "noUsersFound": "Aucun utilisateur trouvé"
    },
    "filters": {
      "allUsers": "Tous les utilisateurs",
      "masterAdminsOnly": "Administrateurs master uniquement",
      "tenantUsersOnly": "Utilisateurs tenant uniquement"
    },
    "values": {
      "active": "Actif",
      "inactive": "Inactif",
      "master": "Référentiel",
      "masterAdmin": "Administrateur master",
      "no": "Non",
      "platform": "— Plateforme —",
      "tenant": "Tenant",
      "yes": "Oui"
    }
  },
  "plans": {
    "columns": {
      "code": "Code",
      "name": "Nom",
      "description": "Descriptif",
      "monthly": "Mensuel",
      "yearly": "Annuel",
      "maxStores": "Magasins max.",
      "maxEmployees": "Employés max.",
      "maxProducts": "Produits max."
    }
  },
  "settings": {
    "actions": {
      "reload": "Recharger",
      "savePlatformSettings": "Enregistrer les paramètres de plateforme",
      "sendTestEmail": "Envoyer un e-mail de test",
      "updatePassword": "Mettre à jour le mot de passe"
    },
    "breadcrumbs": {
      "master": "Référentiel",
      "settings": "Paramètres"
    },
    "help": {
      "mailLocalIn": "dans",
      "mailLocalPrefix": "Local : définissez",
      "mailProduction": "Production : définissez les variables serveur ou enregistrez ici (la base de données remplace l'environnement).",
      "platformOverridePrefix": "Les valeurs enregistrées ici remplacent",
      "platformOverrideSuffix": "/ l'environnement pour le SSO, l'e-mail, CORS et les limites de débit. Les secrets ne sont jamais affichés après l'enregistrement."
    },
    "labels": {
      "enabled": "Activé",
      "enableSso": "Activer le SSO"
    },
    "nav": {
      "platformConfig": "Configuration plateforme",
      "platformConfigDescription": "SSO, e-mail, CORS et limites de débit",
      "twoFactorAuth": "Authentification à deux facteurs",
      "twoFactorAuthDescription": "Protégez votre compte master",
      "yourPassword": "Votre mot de passe",
      "yourPasswordDescription": "Mettez à jour votre mot de passe de connexion"
    },
    "placeholders": {
      "enterSecret": "Saisir le secret",
      "keepExistingSecret": "••••••••  (laisser vide pour conserver)",
      "oauthCallbackBaseUrl": "https://api.yourdomain.com/api",
      "testEmail": "vous@exemple.com"
    },
    "providers": {
      "google": "Google",
      "microsoft": "Microsoft"
    },
    "status": {
      "emailNotFullyConfigured": "L'e-mail n'est pas entièrement configuré — renseignez l'e-mail expéditeur, l'hôte SMTP, le nom d'utilisateur et le mot de passe, puis enregistrez.",
      "outboundEmailConfigured": "L'e-mail sortant est configuré (SMTP + adresse expéditeur)"
    }
  },
  "organizations": {
    "actions": {
      "addOrganization": "Ajouter une organisation"
    },
    "columns": {
      "created": "Créé",
      "email": "E-mail",
      "name": "Nom",
      "orgCode": "Code org.",
      "phone": "Téléphone",
      "plan": "Forfait",
      "status": "Statut"
    },
    "hints": {
      "orgCode": "1 à 3 lettres ou chiffres. Laissez vide pour générer depuis le nom."
    },
    "modal": {
      "editOrganization": "Modifier l'organisation",
      "newOrganization": "Nouvelle organisation"
    }
  },
  "customPlans": {
    "actions": {
      "createPlan": "Créer le plan"
    },
    "columns": {
      "contactEmail": "E-mail de contact",
      "message": "Message",
      "organization": "Organisation",
      "requested": "Demandé",
      "status": "Statut",
      "submitted": "Soumis"
    },
    "defaults": {
      "description": "Plan personnalisé pour l'organisation",
      "organizationId": "Org. n° {{id}}",
      "planName": "Personnalisé — {{organization}}"
    },
    "modal": {
      "planFor": "Plan pour {{name}}"
    },
    "requestedLimits": "{{stores}} magasins · {{staff}} employés · {{products}} produits",
    "status": {
      "planReady": "Plan prêt"
    }
  },
  "formActions": {
    "publishPlan": "Publier le plan"
  },
  "framework": {
    "loadFailed": "Échec du chargement de {{name}}",
    "savedSuccessfully": "Enregistré avec succès",
    "saveFailed": "Échec de l'enregistrement",
    "restoreRecord": "Restaurer l'enregistrement",
    "deactivateRecord": "Désactiver l'enregistrement",
    "restoreConfirm": "Restaurer {{name}} ?",
    "deactivateConfirm": "Désactiver {{name}} ?",
    "restore": "Restaurer",
    "deactivate": "Désactiver",
    "recordRestored": "Enregistrement restauré",
    "recordDeactivated": "Enregistrement désactivé",
    "restoreFailed": "Échec de la restauration",
    "deactivateFailed": "Échec de la désactivation",
    "deleteRecord": "Supprimer l'enregistrement",
    "deleteConfirm": "Supprimer {{name}} ?",
    "delete": "Supprimer",
    "recordDeleted": "Enregistrement supprimé",
    "deleteFailed": "Échec de la suppression",
    "status": "Statut",
    "importSubmitted": "Import envoyé",
    "exportStarted": "Export démarré",
    "newEntity": "Nouveau {{name}}",
    "editEntity": "Modifier {{name}}"
  },
  "localization": {
    "translations": {
      "title": "Gestion des traductions",
      "description": "Gérez les clés de traduction, les valeurs par langue, les diagnostics, l'import/export et l'historique des versions.",
      "language": "Langue",
      "module": "Module",
      "allModules": "Tous les modules",
      "search": "Recherche",
      "searchPlaceholder": "Rechercher des clés ou des valeurs",
      "refresh": "Actualiser",
      "export": "Exporter",
      "import": "Importer",
      "importJson": "Importer du JSON",
      "importPlaceholder": "Collez un tableau d'entrées de traduction",
      "editTitle": "Modifier la traduction",
      "key": "Clé",
      "value": "Valeur",
      "actions": "Opérations",
      "edit": "Modifier",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "empty": "Aucune traduction trouvée",
      "noDiagnostics": "Aucun diagnostic de traduction trouvé",
      "status": "Statut",
      "fallback": "Valeur de secours",
      "loadHistory": "Charger l'historique",
      "noHistory": "Aucun historique de version trouvé",
      "oldValue": "Ancienne valeur",
      "newValue": "Nouvelle valeur",
      "loadFailed": "Échec du chargement des traductions",
      "saveFailed": "Échec de l'enregistrement de la traduction",
      "saved": "Traduction enregistrée et appliquée",
      "exportFailed": "Échec de l'export des traductions",
      "exported": "Traductions copiées dans le presse-papiers",
      "importFailed": "Échec de l'import des traductions",
      "imported": "Traductions importées et appliquées",
      "tabs": {
        "translations": "Traductions",
        "missing": "Clés manquantes",
        "unused": "Clés inutilisées",
        "history": "Historique des versions",
        "import": "Importer"
      }
    }
  }
}
